<button mdbBtn [size]="size" type="button" [outline]="outline" [rounded]="rounded" [color]="color" [disabled]="disabled"
    (click)="onClick()" mdbWavesEffect>{{title}}</button>